import React from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "@/services/store";
import { calendarSliceActions } from "@/features/calendar/model";
import styles from "./styles.module.scss";

interface Props {
  className?: string;
}

export const CalendarFooter: React.FC<Props> = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    dispatch(calendarSliceActions.updateDateRange(new Date().toISOString()));
  };

  return (
    <div className={styles.footer} onClick={handleClick}>
      {t("common.today")}
    </div>
  );
};
